<script>
	import { onMount } from "svelte";

	export let id;
	export let slideProgress;
	export let content = {};

	let played = false;
	let mounted = false;

	onMount(() => {
		mounted = true;
	});

	$: if (mounted && slideProgress === 0 && played) {
		played = false;
	}

	$: if (mounted && slideProgress !== 0 && slideProgress !== 1 && !played) {
		played = true;
	}
</script>

<div class="content">
	<div class="heading">{@html content.heading}</div>
	{#if content.text}
		<div class="t-copy-sans">{@html content.text}</div>
	{/if}
</div>

<style lang="scss">
	.content {
		font-size: 46px;
		line-height: 1.25;
		max-width: 530px;
		text-align: center;
		width: 100%;
		margin: 50px auto 125px auto;

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			font-size: 36px;
			margin: 50px auto 80px auto;
			width: 50%;
		}

		@media (max-width: $breakpoint-mobile) {
			font-size: 30px;
			margin: 50px auto 60px auto;
		}
	}
</style>
